//
//
//
//

import * as echarts from 'echarts/core'
import { TooltipComponent, LegendComponent } from 'echarts/components'
import { PieChart } from 'echarts/charts'
import { LabelLayout } from 'echarts/features'
import { CanvasRenderer } from 'echarts/renderers'

echarts.use([
  TooltipComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer,
  LabelLayout,
])

export default {
  name: 'GraphicCard',
  props: {
    /**
     * Required to render the chart
     */
    chartId: {
      type: String,
      default: 'graphic',
    },
    /**
     * Follow Echart Pie option
     */
    option: {
      type: Object,
      default: () => ({}),
    },
    height: {
      type: String,
      default: '400px',
    },
  },
  data() {
    return {
      myChart: null,
    }
  },
  mounted() {
    const chartDom = document.getElementById(this.chartId)
    this.myChart = echarts.init(chartDom)
    window.addEventListener('resize', this.resize)
    this.myChart.setOption(this.option)
  },
  methods: {
    resize() {
      this.myChart.resize()
    },
  },
  destroy() {
    window.removeEventListener('resize', this.resize)
  },
}
